module.exports = __webpack_public_path__ + "static/media/blueLightning.be8b00bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/blueLightning.svg
// module id = 451
// module chunks = 0